/*
 * File: AsanaAddTask.tsx
 * Project: a-a
 * File Created: Thursday, 22nd May 2025 8:42:28 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 13th June 2025 6:26:02 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomDrawer from '../../../shared/CustomDrawer/CustomDrawer';
import zeplinColor from '../../../../theme/Color';
import CustomTextField from '../../../shared/CustomTextField/CustomTextField';
import CustomDatePicker from '../../../shared/CustomDatePicker/CustomDatePicker';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import { useInput } from '../../../../customHook/useInput';
import dayjs, { Dayjs } from 'dayjs';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import CustomDragnDrop from '../../../shared/CustomDragnDrop/CustomDragnDrop';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import { SFService } from '../../../../service/SF.service';
import { AsanaService } from '../../../../service/asana.service';
import { useLocation } from 'react-router-dom';
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};
const AsanaAddTask = ({
  modalOpen,
  setModalOpen,
  data,
  getTask,
  setMessage,
  setEditedProject,
  priority,
  status,
}: {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getTask?: () => void;
  data?: any;
  setMessage: React.Dispatch<React.SetStateAction<string>> | ((val: string) => void);
  setEditedProject?: React.Dispatch<any>;
  status: { label: string; value: string }[];
  priority: { label: string; value: string }[];
}) => {
  const location = useLocation();
  const details = location.pathname?.split('/');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selectedItems, setSelectedItems] = useState<{
    assignTo: string[];
    priority: string[];
    status: string[];
  }>({
    assignTo: data?.task?.assignee?.gid ? [data?.task?.assignee?.gid] : [],
    priority: data?.task?.custom_fields?.length
      ? data?.task?.custom_fields?.filter((val: any) => val?.name === 'Priority')?.length
        ? [
            data?.task?.custom_fields?.filter((val: any) => val?.name === 'Priority')[0]?.enum_value
              ?.gid,
          ]
        : []
      : [],
    status: data?.task?.custom_fields?.length
      ? data?.task?.custom_fields?.filter((val: any) => val?.name === 'Status')?.length
        ? [
            data?.task?.custom_fields?.filter((val: any) => val?.name === 'Status')[0]?.enum_value
              ?.gid,
          ]
        : []
      : [],
  });
  const [assignedTo, setAssignedTo] = useState<{ id: string; name: string }[]>();
  const {
    handleChange: handleSubjectChange,
    handleBlur: handleSubjectBlur,
    clearInput: clearSubject,
    value: subject,
    invalid: invalidSubject,
    didChange: didSubjectChange,
    setValue: setSubjectChange,
    setDidChange: setDidSubjectChange,
  } = useInput(data?.task?.name ? data?.task?.name : '', (val) =>
    val?.trim().length ? true : false,
  );

  const getFilter = async () => {
    try {
      const res = await AsanaService.getAsanaFilter();
      console.log(res);
      setAssignedTo(res.members);
    } catch (err) {
      console.log(err);
    }
  };
  const [date, setDate] = useState<Dayjs | null>(
    data?.task?.due_on
      ? dayjs(data?.task?.due_on).date()
        ? dayjs(data?.task?.due_on)
        : dayjs(new Date())
      : null,
  );
  const [attachments, setAttachments] = useState<{
    removed: any;
    added: any;
  }>({
    removed: [],
    added: [],
  });
  const [selectedFiles, setSelectedFiles] = useState<File[]>(
    data?.attachments ? [...data?.attachments] : [],
  );
  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      console.log(event.target.files, Array.from(event.target.files));
      onDrop(Array.from(event.target.files));
    }
  };

  const {
    handleChange: handleCommentChange,
    handleBlur: handleCommentBlur,
    clearInput: clearComment,
    value: comment,
    invalid: invalidComment,
    didChange: didCommentChange,
    setValue: setComment,
  } = useInput(data?.task?.notes ? data?.task?.notes : '', () => true);
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setModalOpen(false);
  };
  const handleSelection = (item: any, type: string) => {
    console.log({ item });

    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };
  const deleteAttachment = async (id: string) => {
    try {
      const res = await AsanaService.deleteAsanaAttachments(id);
      setMessage('Deleted attachment successfully');
    } catch (err: any) {
      console.log(err);
      setMessage('Something went wrong');
    }
  };
  const handleDeleteFiles = async (index: number, file: any) => {
    console.log(file);
    setSelectedFiles(selectedFiles?.filter((_, ind) => ind !== index));
    // setAttachments(attachments?.filter((_, ind) => ind !== index));
    setAttachments((prev) => ({
      added: attachments?.added?.filter((val: any, ind: any) => ind !== index),
      removed: 'edit'?.length
        ? [
            ...prev.removed,
            ...selectedFiles?.filter((_, ind) => ind === index).map((val) => val?.toString()),
          ]
        : [...prev.removed, ...attachments?.added?.filter((val: any, ind: any) => ind === index)],
    }));
    file?.gid && (await deleteAttachment(file?.gid));
  };
  useEffect(() => {
    //   modalOpen && getTeams();
    getFilter();

    if (!modalOpen) {
      setSubjectChange('');
      setComment('');
      setDidSubjectChange(false);
      setSelectedItems({ assignTo: [], priority: [], status: [] });
      getTask && data?.task?.gid && getTask();
    }
  }, [modalOpen]);

  const handleClose = () => {
    setError(false);
  };
  const uploadFile = async (data: any) => {
    console.log(data);
    try {
      // const res = await AsanaService.addAsanaAttachments(details[2], acceptedFiles[0]);
      console.log(selectedFiles);
      const res = await AsanaService.addAsanaAttachments(data, selectedFiles);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };
  const onDrop = async (acceptedFiles: File[]) => {
    // Do something with the files
    console.log(acceptedFiles);
    setSelectedFiles((prev) => [...prev, ...acceptedFiles]);
    // track new changes to call attachment api.
    setAttachments({
      added: [...attachments.added, acceptedFiles[0]],
      removed: [...attachments.removed],
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const res = data?.task?.gid
        ? await AsanaService.editAsanaTask(data?.task?.gid, {
            completed: data?.task?.completed,
            notes: comment,
            assignee: selectedItems?.assignTo[0],
            projectId: details[2],
            priority: selectedItems?.priority[0],
            status: selectedItems?.status[0],
            name: subject,
          })
        : await AsanaService.createAsanaTask(details[2], {
            name: subject,
            dueDate: date,
            assignee: selectedItems?.assignTo[0],
            notes: comment,
            priority: selectedItems?.priority[0],
            status: selectedItems?.status[0],
          });

      const attachementRes = attachments?.added.length && (await uploadFile(res?.gid));
      setModalOpen(false);
      setMessage(`Task ${data?.task?.gid ? 'edited' : 'added'} successfully`);
      console.log(res, attachementRes);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {modalOpen && (
        <CustomDrawer state={modalOpen} onClose={onClose(false)}>
          <Box
            sx={{
              width: '492px',
              position: 'relative',
              overflowY: 'scroll',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              height: '100vh',
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '40px 24px 24px 24px',
                }}
              >
                <Typography variant='heading2'>
                  {data?.task?.assignee?.gid ? 'Edit Task' : 'New Task'}
                </Typography>

                <img
                  src={'/assets/close-icon.svg'}
                  width={24}
                  height={24}
                  alt='close'
                  style={{ cursor: 'pointer' }}
                  onClick={onClose(false)}
                />
              </Box>

              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                padding: '0px 24px 24px 24px',
                flex: 1,
              }}
            >
              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleSubjectBlur}
                onChange={handleSubjectChange}
                name='Subject'
                text={subject}
                error={invalidSubject && didSubjectChange ? 'Please enter valid subject' : ''}
                label={'Subject'}
                type='text'
                tabindex={1}
                required
              />
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Assign to<span style={{ color: zeplinColor.Error }}>*</span>
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  required={true}
                  value={selectedItems.assignTo}
                  onChange={(e) => handleSelection(e, 'assignTo')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                      }}
                      label='Assign to'
                    />
                  }
                  renderValue={
                    (selected) =>
                      // (selected as string[]).map((val) => (
                      {
                        return selected?.length
                          ? assignedTo?.length &&
                              assignedTo.filter((val) => val?.id === selected[0])[0].name
                          : '';
                      }
                    // ))
                  }
                  MenuProps={MenuProps}
                  IconComponent={KeyboardArrowDown}
                >
                  {assignedTo?.length &&
                    assignedTo.map((name) => (
                      <MenuItem key={name?.id} value={name?.id}>
                        <Radio
                          checked={
                            selectedItems?.assignTo?.length
                              ? selectedItems?.assignTo?.indexOf(name?.id) > -1
                              : false
                          } // Check if this radio should be selected
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <CustomDatePicker value={date} setValue={setDate} />
              <Box sx={{ display: 'flex', gap: '24px' }}>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Status<span style={{ color: zeplinColor.Error }}>*</span>
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    // multiple
                    required={true}
                    value={selectedItems.status}
                    onChange={(e) => handleSelection(e, 'status')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                        }}
                        label='Privacy'
                      />
                    }
                    renderValue={
                      (selected) =>
                        // (selected as string[]).map((val) => (
                        {
                          return (
                            status?.length &&
                            status.filter((val: any) => val?.value === selected[0])[0]?.label
                          );
                        }
                      // ))
                    }
                    MenuProps={MenuProps}
                    IconComponent={KeyboardArrowDown}
                  >
                    {status?.length &&
                      status.map((name: any) => (
                        <MenuItem key={name?.value} value={name?.value}>
                          <Radio
                            checked={
                              selectedItems?.priority?.length
                                ? selectedItems?.priority?.indexOf(name?.value) > -1
                                : false
                            } // Check if this radio should be selected
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                          {name?.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Priority<span style={{ color: zeplinColor.Error }}>*</span>
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    // multiple
                    required={true}
                    value={selectedItems.priority}
                    onChange={(e) => handleSelection(e, 'priority')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                        }}
                        label='Priority'
                      />
                    }
                    renderValue={
                      (selected) =>
                        // (selected as string[]).map((val) => (
                        {
                          return (
                            priority?.length &&
                            priority.filter((val: any) => val?.value === selected[0])[0]?.label
                          );
                        }
                      // ))
                    }
                    MenuProps={MenuProps}
                    IconComponent={KeyboardArrowDown}
                  >
                    {priority?.length &&
                      priority.map((name: any) => (
                        <MenuItem key={name?.value} value={name?.value}>
                          <Radio
                            checked={
                              selectedItems?.priority?.length
                                ? selectedItems?.priority?.indexOf(name?.value) > -1
                                : false
                            } // Check if this radio should be selected
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                          {name?.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Box>

              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleCommentBlur}
                onChange={handleCommentChange}
                name='Description'
                text={comment}
                error={''}
                label={'Description'}
                type='text'
                tabindex={1}
                multiline
                // required
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                    <img
                      width={'24px'}
                      height={'24px'}
                      src={'/assets/attachment.svg'}
                      alt='logo'
                      style={{ objectFit: 'fill' }}
                    />
                    <Typography variant='body2' color={zeplinColor.BasicBlack}>
                      Attachment
                    </Typography>
                  </Box>

                  {selectedFiles?.length ? (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '8px',
                        width: '100%',
                        alignItems: 'center',
                        flex: 1,
                        justifyContent: 'flex-end',
                        cursor: 'pointer',
                      }}
                      // onClick={OnClickSubtask}
                      onClick={openInput}
                    >
                      <input
                        type='file'
                        id='attachment'
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                      />
                      <img
                        width={'24px'}
                        height={'24px'}
                        src={'/assets/upload-blue.svg'}
                        alt='logo'
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                        Select File
                      </Typography>
                    </Box>
                  ) : (
                    ''
                  )}
                </Box>
                {!selectedFiles?.length ? (
                  <CustomDragnDrop onDrop={onDrop} />
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {selectedFiles.map((file, index) => (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '12px',
                        }}
                      >
                        <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                          <img
                            width={'40px'}
                            height={'40px'}
                            src={
                              file?.name
                                ? `/assets/${file?.name
                                    ?.split('.')
                                    [file?.name?.split('.')?.length - 1].toLocaleLowerCase()}.svg`
                                : `/assets/${file
                                    ?.toString()
                                    .split('.')
                                    [
                                      file?.toString()?.split('.')?.length - 1
                                    ].toLocaleLowerCase()}.svg`
                            }
                            alt='file-type'
                            style={{ objectFit: 'fill' }}
                          />
                          <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                            <LightTooltip
                              title={
                                <Typography variant='body3' color={zeplinColor.Neutral1}>
                                  {file.name}
                                </Typography>
                              }
                              placement='bottom-end'
                              style={{
                                backgroundColor: zeplinColor.BasicBlack,
                                borderRadius: '8px',
                              }}
                            >
                              <Typography variant='body2'>
                                {file?.name
                                  ? file?.name?.slice(0, 40)
                                  : file?.toString()?.slice(0, 40)}
                                {file?.name
                                  ? file?.name?.length > 40 && '...'
                                  : file?.toString()?.length > 40 && '...'}
                              </Typography>
                            </LightTooltip>
                            <Typography variant='label1'>{file.size / 10000}MB</Typography>
                          </Box>
                        </Box>
                        <img
                          width={'24px'}
                          height={'24px'}
                          src={'/assets/delete-blue.svg'}
                          alt='logo'
                          style={{ objectFit: 'fill', cursor: 'pointer' }}
                          onClick={() => handleDeleteFiles(index, file)}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                position: 'sticky',
                bottom: '0px',
                margin: 'auto',
                zIndex: '100',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              <CustomButton
                disabled={!subject || !selectedItems?.assignTo?.length || loading}
                onClick={() => {
                  handleSubmit();
                }}
                variant='contained'
                color={'primary'}
                style={{
                  borderRadius: '14px',
                  height: 56,
                  width: '100%',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={
                  data?.task?.assignee?.gid
                    ? loading
                      ? 'Saving'
                      : 'Save'
                    : loading
                    ? 'Saving'
                    : 'Create Task'
                }
                // tabindex={4}
              />
            </Box>
          </Box>
          <CustomAlert
            open={error ? true : false}
            handleClose={handleClose}
            message={
              <CustomAlertContain
                alert={
                  error
                    ? 'Something went wrong'
                    : data?.id
                    ? 'Edit successfully'
                    : 'Created project successfully'
                }
                alertIcon={
                  !error ? (
                    <img src='/assets/checkmark-green.png' width={24} height={24} />
                  ) : (
                    <img src='/assets/error.svg' width={24} height={24} />
                  )
                }
                error={!error ? false : true}
              />
            }
            error={!error ? false : true}
          />
        </CustomDrawer>
      )}
    </Box>
  );
};

export default AsanaAddTask;
